import { ApiConfig } from 'src/packages/api'

const config: ApiConfig = {
  baseUrl: 'https://goldfish-app-wos4f.ondigitalocean.app/v1',
  sentryDsn:
    'https://f91e85e82e5297ee4475eb5dee3a27f4@o4506099692470272.ingest.sentry.io/4506099693780992',
}
export default config
